/* eslint-disable no-unused-vars */
import { CustomButton, Label, CustomTooltip, Loader } from 'components';
import * as S from './ImageUploadHandler.styled';
import { Question } from 'assets/icons';
import { useComputed } from '@preact/signals-react';

const toolTipStyle = {
  color: '#64748B',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '16px',
};
const labelStyle = { marginLeft: 'auto', marginRight: '2px' };

export const ImageUploadHandler = ({
  onImageUpload,
  isDragging,
  dragProps,
  errors,
  imgIsLoading$,
  resolutionWidth,
  resolutionHeight,
  selectedImgOrVideo$,
}) => {
  return (
    <S.Box>
      <S.Container
        style={{
          flex: errors === null ? '1' : '0',
        }}
        // {...dragProps}
      >
        <S.Wrapper>
          <CustomButton
            btnWrapperStyle={{
              height: '32px',
            }}
            square
            id='delete_selected_creative'
            buttonColor={CustomButton.Colors.Secondary}
            onClick={onImageUpload}
          >
            Upload Creative
          </CustomButton>
          <Label
            variant='description'
            text='or Drag and drop files here'
            style={{ whiteSpace: 'nowrap' }}
          />
        </S.Wrapper>
      </S.Container>
      {errors && !selectedImgOrVideo$.value && (
        <div>
          {errors.acceptType && (
            <Label
              variant='description'
              style={{ color: 'red' }}
              text='Your selected file type is not allowed'
            />
          )}
          {errors.resolution && (
            <Label
              style={{ color: 'red' }}
              text={`Please upload a photo with a resolution higher than ${resolutionWidth}*
              ${resolutionHeight}`}
              variant='description'
            />
          )}
        </div>
      )}
      {useComputed(() => imgIsLoading$.value && <Loader.Local delay={0} />)}
      <div style={{ marginLeft: 'auto', display: 'flex', marginRight: '24px' }}>
        <Label text='Requirements' variant='description' style={labelStyle} />
        <CustomTooltip
          style={toolTipStyle}
          content={<Question />}
          text={
            <p style={{ maxWidth: '150px' }}>
              JPEG or PNG. Please upload image size {resolutionWidth}*{resolutionHeight}. You can
              also upload different image size and adjust it.
            </p>
          }
        />
      </div>
    </S.Box>
  );
};
